export default __webpack_public_path__ + "static/media/iMac Pro Left Side View Mokup.aff562c7.png";